import { render, staticRenderFns } from "./CtaBlock.vue?vue&type=template&id=7b056048&scoped=true&"
import script from "./CtaBlock.vue?vue&type=script&lang=js&"
export * from "./CtaBlock.vue?vue&type=script&lang=js&"
import style0 from "./CtaBlock.vue?vue&type=style&index=0&id=7b056048&prod&lang=scss&"
import style1 from "./CtaBlock.vue?vue&type=style&index=1&id=7b056048&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b056048",
  null
  
)

export default component.exports